import React from "react";
import LegalLayout, { Section, P, UL, LI, Callout } from "./LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout
      code="DOC · 01 / TERMS OF SERVICE"
      title="Terms of Service"
      lastUpdated="December 2025"
    >
      <Section id="acceptance" title="1. Acceptance of Terms">
        <P>
          These Terms of Service ("Terms") govern your access to and use of the
          website <strong>www.sebyx.com</strong> (the "Site") and all services,
          digital products, cohorts, mentorship programs, fractional engagements,
          and proprietary tech offered by <strong>Sebyx</strong> ("Sebyx", "we",
          "us", or "our"). By accessing the Site, purchasing any Sebyx Academy
          tier, or engaging Sebyx for advisory or fractional services, you agree
          to be bound by these Terms.
        </P>
        <P>
          If you do not agree with any part of these Terms, you must not use the
          Site or our services.
        </P>
      </Section>

      <Section id="services" title="2. Services Offered">
        <P>Sebyx provides the following categories of services:</P>
        <UL>
          <LI>
            <strong>Sebyx Academy — Entry (₹3,999 – ₹14,999):</strong> Two entry
            tracks — Frontline Elite (retail) and Rookie Hunter (B2B) — delivered
            as online live cohorts, F2F weekend cohorts, or 1-on-1 personalized
            sessions. 12 hours across 2 days.
          </LI>
          <LI>
            <strong>Sebyx Academy — Pro (₹7,499):</strong> A 4-week live cohort
            ("Master Hunter Certification") with scheduled sessions, live deal
            reviews, and certification on completion.
          </LI>
          <LI>
            <strong>Sebyx Academy — Elite (₹24,999):</strong> A personalized
            30-day Executive 1-on-1 Mentorship engagement, delivered remotely
            and/or in person at mutual convenience.
          </LI>
          <LI>
            <strong>BDaaS & Fractional Leadership:</strong> Custom B2B sales
            consulting, market entry, team scaling, and demand generation,
            scoped through a written Statement of Work.
          </LI>
          <LI>
            <strong>Proprietary Tech Solutions:</strong> AI-powered prospecting,
            Med-Tech Sales OS, and field intelligence software, licensed under
            separate written agreements.
          </LI>
        </UL>
      </Section>

      <Section id="eligibility" title="3. Eligibility">
        <P>
          You must be at least 18 years of age and competent to enter into a
          legally binding contract under the Indian Contract Act, 1872, to use
          paid Sebyx services. By making a purchase, you represent that the
          information you provide is accurate, complete, and truthful.
        </P>
      </Section>

      <Section id="account" title="4. Accounts & Access">
        <P>
          For programs that require login (cohort access, mentorship rooms, or
          tech licenses), you are responsible for maintaining the
          confidentiality of your credentials and for all activity conducted
          under your account. Sharing access with non-enrolled persons is a
          material breach of these Terms.
        </P>
      </Section>

      <Section id="payments" title="5. Payments & Pricing">
        <UL>
          <LI>
            All prices are in Indian Rupees (INR / ₹) and are inclusive of
            applicable taxes unless stated otherwise.
          </LI>
          <LI>
            Payments for Sebyx Academy are processed by{" "}
            <strong>Razorpay Software Private Limited</strong>. By purchasing,
            you also accept Razorpay's terms.
          </LI>
          <LI>
            Sebyx is not liable for failed transactions arising from
            payment-gateway, network, or banking errors. Failed amounts that
            are debited will be auto-reversed by your bank within 5–10 working
            days as per RBI guidelines.
          </LI>
        </UL>
      </Section>

      <Section id="cohort" title="6. Cohort & Mentorship Conduct">
        <P>
          Pro cohort participants and Elite mentees agree to attend scheduled
          sessions punctually, treat fellow participants and faculty with
          respect, and refrain from recording or redistributing live sessions
          without prior written consent. Sebyx reserves the right to remove
          participants who breach this clause without refund.
        </P>
      </Section>

      <Section id="ip" title="7. Intellectual Property">
        <P>
          All curriculum materials, frameworks, scripts, decks, software,
          trademarks, and trade secrets made available through the Site or any
          Sebyx program remain the exclusive property of Sebyx. You receive a
          limited, non-exclusive, non-transferable license to use them for your
          personal professional development only. You may not republish, resell,
          repackage, or train any model on this content.
        </P>
      </Section>

      <Section id="confidentiality" title="8. Confidentiality (Fractional & Mentorship)">
        <P>
          During fractional engagements and Elite mentorship, both parties may
          exchange confidential business information. Each party agrees to
          treat such information with the same standard of care as its own
          confidential information for a period of three (3) years following
          engagement closure.
        </P>
      </Section>

      <Section id="liability" title="9. Limitation of Liability">
        <P>
          Sebyx provides advisory, education, and software services on an
          "as-is" basis. We do not guarantee any specific revenue, hiring, or
          career outcome. To the maximum extent permitted by law, Sebyx's
          aggregate liability for any claim arising out of or relating to the
          Services shall not exceed the fees paid by you to Sebyx in the
          twelve (12) months preceding the event giving rise to the claim.
        </P>
        <Callout>
          Sebyx is not liable for indirect, incidental, consequential, or
          punitive damages, including loss of profits, goodwill, or business
          opportunity.
        </Callout>
      </Section>

      <Section id="termination" title="10. Termination">
        <P>
          Sebyx may suspend or terminate your access to any service immediately,
          without prior notice, if you breach these Terms, abuse staff or peers,
          or attempt to reverse-engineer proprietary tech. Termination clauses
          do not entitle you to a refund except as described in our Refund
          Policy.
        </P>
      </Section>

      <Section id="governing-law" title="11. Governing Law & Jurisdiction">
        <P>
          These Terms shall be governed by and construed in accordance with the
          laws of India. Any dispute arising out of or in connection with these
          Terms shall be subject to the exclusive jurisdiction of the courts at{" "}
          <strong>Bengaluru, Karnataka</strong>.
        </P>
      </Section>

      <Section id="contact" title="12. Contact">
        <P>
          For any questions regarding these Terms, please write to{" "}
          <a
            href="mailto:contact@sebyx.com"
            className="text-sebyx-accent hover:underline"
          >
            contact@sebyx.com
          </a>{" "}
          or call{" "}
          <a
            href="tel:+919108436667"
            className="text-sebyx-accent hover:underline"
          >
            +91 91084 36667
          </a>
          .
        </P>
      </Section>
    </LegalLayout>
  );
}
